{#if option.type === "text"}
<ListInput
  type="text"
  placeholder={option.label || option.key}
  info={option.helpText || ""}
  clearButton
  {value}
  on:change={(e) => handleInputChange(e)}
/>
{:else if option.type === "background"}
<CardsEditorBackgroundConfigListItem {option} {value} on:change />
{/if}

<style>
  *, *::before, *::after {
    box-sizing: border-box;
  }</style>

<script lang="ts">import { ListInput } from 'framework7-svelte';
import './CardsEditorComponentInterfaces';
import './context';
import { createEventDispatcher } from 'svelte';
import CardsEditorBackgroundConfigListItem from './CardsEditorBackgroundConfigListItem.svelte';
export let option;
export let value;
const dispatch = createEventDispatcher();
function handleInputChange(e) {
    var _a;
    //console.log("handleInputChange", e);
    let input = (_a = e === null || e === void 0 ? void 0 : e.detail) === null || _a === void 0 ? void 0 : _a[0].target;
    if (input) {
        value = input.value;
        dispatch('change', { value });
    }
}
</script>